import {
    URLAPI,
    SHIPPING_REQUEST_PATH,
    SHIPPING_REQUEST_CREATE_PATH,
    SHIPPING_REQUEST_UPDATE_PATH,
    SHIPPING_REQUEST_REPORT_PATH,
    SHIPPING_REQUEST_ITEM_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _get_all_shipping_request: {
        data: [],

        status: 0,
        message: {},
    },
    _create_shipping_request: {
        data: {},
        status: 0,
        message: {},
    },
    _update_shipping_request: {
        data: {},
        status: 0,
        message: {},
    },
    _get_report: {
        data: {},
        status: 0,
        message: "",
    },
};

const GET_ALL_SHIPPING_REQUEST = "GET_ALL_SHIPPING_REQUEST";
export const CREATE_SHIPPING_REQUEST = "CREATE_SHIPPING_REQUEST";
export const UPDATE_SHIPPING_REQUEST = "UPDATE_SHIPPING_REQUEST";
export const GET_REPORT = "GET_REPORT";

export const shipping_request_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_SHIPPING_REQUEST:
            return {
                ...state,
                _get_all_shipping_request: action.payload,
            };
        case CREATE_SHIPPING_REQUEST:
            return {
                ...state,
                _create_shipping_request: action.payload,
            };
        case UPDATE_SHIPPING_REQUEST:
            return {
                ...state,
                _update_shipping_request: action.payload,
            };
        case GET_REPORT:
            return {
                ...state,
                _get_report: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllShippingRequest = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${SHIPPING_REQUEST_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_SHIPPING_REQUEST,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_SHIPPING_REQUEST,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_SHIPPING_REQUEST,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const getItemShippingRequest = async (token, id) => {
    return await axios.get(`${URLAPI}${SHIPPING_REQUEST_ITEM_PATH}${id}/`, {
        headers: {
            Authorization: `Token ${token}`,
        },
    });
};

export const searchShippingRequest = async (token, paramsUrl) => {
    return await axios.get(`${URLAPI}${SHIPPING_REQUEST_PATH}${paramsUrl}`, {
        headers: {
            Authorization: `Token ${token}`,
        },
    });
};

//create shipping_request
export const createShippingRequest = (token, data) => async (dispatch) => {
    try {
        const response = await axios.post(
            `${URLAPI}${SHIPPING_REQUEST_CREATE_PATH}`,
            data,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_SHIPPING_REQUEST,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_SHIPPING_REQUEST,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_SHIPPING_REQUEST,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateShippingRequest = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${SHIPPING_REQUEST_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_SHIPPING_REQUEST,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: UPDATE_SHIPPING_REQUEST,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_SHIPPING_REQUEST,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const get_report = (data, token) => async (dispatch) => {
    try {
        const res = await axios.post(URLAPI + SHIPPING_REQUEST_REPORT_PATH, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });

        dispatch({
            type: GET_REPORT,
            payload: {
                data: res.data,
                status: res.status,
                message: "",
            },
        });
    } catch (e) {
        dispatch({
            type: GET_REPORT,
            payload: {
                data: {},
                status: 500,
                message: "Ocurrio un error al generar el reporte",
            },
        });
    }
};

export const clear_shipping_request = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
